import { Component, Input, OnInit, AfterViewInit } from '@angular/core';
import { Subject } from 'rxjs';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { GlobalVariableService } from '../../../../services/configuration/global-variable.service';
import { GenericModalService } from '../../../../services/generic-modal.service';

@Component({
  selector: 'app-global-variable-modal',
  templateUrl: './global-variable-modal.component.html',
  styleUrls: ['./global-variable-modal.component.css', '../../../../styles/modals.css']
})
export class GlobalVariableModalComponent implements OnInit, AfterViewInit {

  get formData() { return this.globalVariableForm.controls; }

  constructor(
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private globalVariableService: GlobalVariableService,
    private modalService: GenericModalService
  ) { }

  @Input() modalTitle: string;
  itemSaved: Subject<boolean> = new Subject();
  globalVariableForm: FormGroup;
  objInitialState: any;
  submitted = false;
  submitClick = false;
  errorMessage = '';
  isNew: boolean;
  globalVariableValue: string;

  ngOnInit() {
    this.isNew = this.objInitialState.globalVariableName === undefined;
    this.createForm();
  }

  ngAfterViewInit() {
    if (this.objInitialState.globalVariableName) {
      this.patchVariableGroupValues();
    }
  }

  createForm() {
    this.globalVariableForm = this.formBuilder.group({
      globalVariableName: [ '', Validators.compose( [
        Validators.required,
        Validators.maxLength(30),
        Validators.pattern('^[a-zA-Z][a-zA-Z0-9_]*') ])
      ],
      description: ['', [Validators.maxLength(200) ]],
      isEncrypted: false,
      value: [ '', Validators.maxLength(2000)]
    });
  }

  patchVariableGroupValues() {
    this.globalVariableForm.controls.globalVariableName.disable();
    this.objInitialState.isEncrypted ? this.globalVariableValue = '•'.repeat(10)
      : this.globalVariableValue = this.objInitialState.value;
    this.globalVariableForm.patchValue({
      globalVariableName: this.objInitialState.globalVariableName,
      description: this.objInitialState.description,
      isEncrypted: this.objInitialState.isEncrypted,
      value: this.objInitialState.value
    });
  }

  onSave() {
    const globalVariable = this.globalVariableForm.getRawValue();
    if (this.isNew) {
      globalVariable.value = this.globalVariableValue ? this.globalVariableValue.trim() : '';
      this.createNewGlobalVariable(globalVariable);
    } else {
      if (this.globalVariableValue !== '••••••••••') {
        globalVariable.value = this.globalVariableValue ? this.globalVariableValue.trim() : '';
      }
      this.updateGlobalVariable(globalVariable);
    }
  }

  onChangeEncryptSettings(currentIsEncrypted: boolean) {
    const encryptedSettingsChanged = currentIsEncrypted !== this.objInitialState.isEncrypted;
    if (!this.isNew && encryptedSettingsChanged) {
      const message = currentIsEncrypted ?
        'O valor da variável será criptografado para todos os grupos de configuração. Deseja continuar?'
        : 'O valor da variável deixará de ser criptografado para todos os grupos de configuração e seu valor deverá ser redefinido. Deseja continuar?';
      let alert: any;
      alert = this.modalService
        .showConfirmModal('Mudança na criptografia', message);
      alert.then( resp => {
        if (resp.value) {
          if (!currentIsEncrypted) {
            this.globalVariableValue = '';
          }
        } else {
          this.globalVariableForm.patchValue({
            isEncrypted: this.objInitialState.isEncrypted
          });
        }
      });
    }
  }

  onClose() {
    this.itemSaved.next(false);
    this.bsModalRef.hide();
  }

  createNewGlobalVariable(globalVariable) {
    this.errorMessage = '';
    this.globalVariableService.saveGlobalVariable(globalVariable)
      .subscribe( () => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error1 => {
          let err = error1;
          if (error1.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitClick = false;
        });
  }

  updateGlobalVariable(globalVariable) {
    this.errorMessage = '';
    this.globalVariableService.updateGlobalVariable(globalVariable)
      .subscribe( () => {
          this.submitted = true;
          this.itemSaved.next(true);
          setTimeout(() => { this.submitted = false; this.bsModalRef.hide(); }, 2000);
        },
        error1 => {
          let err = error1;
          if (error1.indexOf('401') !== -1) {
            err = 'Erro: Sessão expirada.';
          }
          this.errorMessage = err;
          this.submitClick = false;
        });
  }

  clean() {
    if (this.objInitialState.isEncrypted && this.globalVariableValue === '••••••••••') {
      this.globalVariableValue = '';
    }
  }

}
